// Business info — edit these values anytime.
export const BUSINESS = {
  name: "Austin Abatement",
  tagline: "Haul it. Clear it. Done.",
  domain: "www.austinabate.com",
  phone: "(512) 555-0142",
  phoneRaw: "+15125550142",
  email: "hello@austinabate.com",
  city: "Austin, TX",
  serviceArea: "Greater Austin & surrounding Hill Country",
  hours: [
    { d: "Mon – Fri", h: "7:00 AM – 7:00 PM" },
    { d: "Saturday", h: "8:00 AM – 5:00 PM" },
    { d: "Sunday", h: "By appointment" },
  ],
  founded: "2016",
};

export const SERVICES = [
  { code: "01", name: "Single Item Pickup", price: "from $75", desc: "One couch, one fridge, one problem — gone in an afternoon." },
  { code: "02", name: "Full Property Cleanout", price: "from $450", desc: "Estates, foreclosures, evictions. We clear the whole footprint." },
  { code: "03", name: "Garage & Attic Haul", price: "from $180", desc: "Decades of stuff, boxed, sorted, and carried out for you." },
  { code: "04", name: "Construction Debris", price: "from $300", desc: "Drywall, lumber, tile, and remodel waste hauled to spec." },
  { code: "05", name: "Appliance & E-Waste", price: "from $60", desc: "Responsible drop-off for metal, electronics, and appliances." },
  { code: "06", name: "Yard & Storm Debris", price: "from $150", desc: "Brush, branches, and post-storm mess cleared fast." },
];

export const TRIP_ZONES = [
  { zone: "Zone A", area: "Inside Austin city limits", fee: "No trip fee", eta: "Same / next day" },
  { zone: "Zone B", area: "Round Rock · Pflugerville · Cedar Park", fee: "+$25 trip fee", eta: "1–2 days" },
  { zone: "Zone C", area: "Georgetown · Buda · Kyle · Dripping Springs", fee: "+$45 trip fee", eta: "2–3 days" },
  { zone: "Zone D", area: "Out-of-town / Hill Country (30+ mi)", fee: "+$1.25 / mile", eta: "Scheduled" },
];
